import 'colresizable/colResizable-1.6.min';

// colResizable recalculates all initialized tables' column widths on window
// resize by briefly dropping table-layout:fixed and re-measuring, which
// shrinks columns whose content is narrower than their saved width (e.g.
// after opening devtools, or after removing rows). Column dragging is
// handled separately (mousedown/mousemove), so this doesn't affect that.
$(window).off('resize.JColResizer');

let Masonry = require('masonry-layout');

$(document).ready(function (e) {

    let $body = $('body');

    // if($('.sidebar-table-container').length){
    //     $.ajax({
    //         type : 'GET',
    //         url : '/sidebar/menu',
    //         success : function(res){
    //             let $sidebar_container = $('.sidebar-table-container'),
    //                 $loader = $sidebar_container.find('.sidebar-loader');
    //
    //             $loader.remove();
    //             $sidebar_container.append(res);
    //         }
    //     })
    // }

    if ($('.browse-cards').length && !is_mobile) {
        new Masonry('.browse-cards', {});
    }

    var $browse_cards = $('.browse-cards');

    if (is_mobile && $browse_cards.length) {
        var cards_loading = false,
            all_loaded = false;

        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() === $(document).height()) {
                let $page_container = $('.page-container'),
                    loaded = $page_container.attr('data-loaded'),
                    table = $page_container.attr('data-table-id'),
                    searching = $('#search-records').val().length;

                if (all_loaded || cards_loading || searching) {
                    return;
                }

                cards_loading = true;

                // Get the current URL and extract the query parameters if any
                let currentUrl = new URL(window.location.href);
                let params = currentUrl.searchParams;
                let paramObj = {};

                // Convert the search params to an object
                params.forEach((value, key) => {
                    paramObj[key] = value;
                });

                // Add the 'skip' parameter
                paramObj['skip'] = loaded;

                $.ajax({
                    type: 'GET',
                    url: '/infinite-browse/' + table + '/card',
                    data: paramObj,  // Pass the parameters with the request
                    success: function (res) {
                        cards_loading = false;
                        let count = parseInt(loaded) + parseInt(res.count);
                        $page_container.attr('data-loaded', count);
                        $page_container.find('.browse-cards').append(res.records);

                        if (!parseInt(res.count)) {
                            all_loaded = true;
                        }
                    }
                });
            }
        });
    }

    $('.section-link').overflowing('.related-tabs');

    let $overflowed_sections = $('.section-link.overflowing');
    if ($overflowed_sections.length) {
        $('.section-link-container').removeClass('d-none');
    }
    $overflowed_sections.each(function (index, element) {
        $(element).detach().appendTo('.section-link-dropdown')
    });
    $('.related-tabs').removeClass('invisible');

    function initResizableBrowseTable($table) {
        let $head = $table.find('thead'),
            ignore = [];

        // Utility/icon columns (checkbox, buttons, attachments, expand toggle) always
        // render with an empty data-col - real field columns always carry their field id,
        // even when they also happen to carry the fixed-th class in the no-checkbox case
        $head.find('th').each(function (index) {
            if ($(this).attr('data-col') === '') {
                ignore.push(index);
            }
        });

        console.log(ignore);

        $table.colResizable({
            disabledColumns: ignore,
            liveDrag: true,
            onResize: function (e) {
                let $container = $(e.currentTarget),
                    $headers = $container.find('thead th');

                $headers.each(function (index, $header) {
                    let id = $($header).attr('data-col'),
                        section_id = $($header).attr('data-section'),
                        type = section_id ? 'section' : 'browse';

                    if (id && id.length) {
                        let width = $($header).outerWidth();

                        $.ajax({
                            type: 'POST',
                            url: '/tables/fields/width',
                            data: {
                                id,
                                width,
                                section_id,
                                type
                            },
                            success: function (res) {
                                console.log(res);
                            }
                        })
                    }
                });
            }
        });
    }

    $(".resizeable-table").each(function (index, $table) {
        initResizableBrowseTable($($table));
    });

    function initResizableButtonContainer($table) {
        $table.colResizable({
            liveDrag: true,
            gripInnerHtml: "<div class='grip'></div>",
            onResize: function (e) {
                let $container = $(e.currentTarget),
                    $headers = $container.find('tbody td'),
                    type = '',
                    source_id = '';

                if ($container.hasClass('section-insert-container')) {
                    type = 'section_insert';
                } else {
                    type = 'quick_add';
                }

                source_id = $container.attr('data-source-id');

                $headers.each(function (index, $header) {
                    let id = $($header).attr('data-field');
                    if (id && id.length) {
                        let width = $($header).outerWidth();

                        $.ajax({
                            type: 'POST',
                            url: '/tables/fields/width',
                            data: {
                                id,
                                width,
                                source_id,
                                type
                            },
                            success: function (res) {
                                console.log(res);
                            }
                        })
                    }
                });
            }
        });
    }

    $('table.button-container').each(function (index, $table) {
        initResizableButtonContainer($($table));
    });

    $(document).on('click', '.btn-link-accordion', '.sorting-accordion', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $('.sorting-accordion').find('.collapse').removeClass('show');
        $(this).siblings('.collapse').toggleClass('show');
    });

    $(document).on('click', '.ascending, .descending', function (e) {
        let name = $(this).data('field-name'),
            order = $(this).data('sort-by'),
            type = $(this).data('type'),
            $btn = $('#browse-sort-btn'),
            field = $(this).parents('.sort-field').find('.btn-link').text().trim(),
            order_translation = {
                'asc': $btn.attr('data-asc'),
                'desc': $btn.attr('data-desc'),
            };

        let text = `${field} / ${order_translation[order]}`;

        $btn.text(text);
        $('.clear-sorting').removeClass('d-none');

        $('.ascending, .descending').removeClass('active');
        $(this).addClass('active');

        $('.sorting-dropdown').attr('data-sort-field', name).attr('data-sort-order', order);
    });

    $(document).on('click', '.clear-sorting', function (e) {
        $(this).addClass('d-none');
        $('#browse-sort-btn').text($(this).data('text'));
        $('.sorting-dropdown').attr('data-sort-field', '').attr('data-sort-order', '');
        $('.sorting-dropdown').find('.ascending').removeClass('active');
        $('.sorting-dropdown').find('.descending').removeClass('active');
    });

    // Shared with table_relation.js so opening the expand-edit modal also
    // collapses any open browse-detail row instead of leaving it stale underneath.
    window.closeBrowseDetailRows = function () {
        $('.browse-detail-row').each(function () {
            const $detailRow = $(this);
            const $table = $detailRow.prev('tr').closest('table.resizeable-table');
            if ($table.length) {
                $table.prev('.JCLRgrips').show();
            }
        });
        $('.browse-detail-row').remove();
        $('.open-browse-sections').removeClass('fa-angle-up').addClass('fa-angle-down');
        $('.table_container').off('scroll.browseSectionSync');
    };

    $(document).on('click', '.open-browse-sections', function (e) {
        const $icon = $(this);
        const $row = $icon.closest('tr');
        const $table = $row.closest('table.resizeable-table');
        const colSpan = $row.find('td').length;
        const recordId = $icon.data('id');
        const tableId = $icon.data('table-id');
        const $existingDetailRow = $('#detail-row-' + recordId);

        // The row's <td> spans every column of the parent table, which can be wider
        // than what's actually visible when the table overflows its scroll container -
        // cap the injected section content to the visible width instead of letting it
        // stretch into the overflowed area
        const $scrollContainer = $table.closest('.table_container');
        // Matches the "12px 16px" padding set on the detail row's <td> below, plus the
        // extra left padding _custome-styles.scss adds once a .browse-table has
        // rendered (room for the accent bar), plus a little extra so nothing clips
        const cellPadding = 80;

        // Loading the real section content can make the row tall enough that
        // $scrollContainer needs a vertical scrollbar it didn't have before, which
        // shrinks its clientWidth - compute this fresh each time instead of once
        // upfront, or the cap goes stale and the viewport ends up a bit too wide
        const applyViewportWidth = function ($viewport) {
            if (!$scrollContainer.length) {
                return;
            }

            const visibleWidth = $scrollContainer[0].clientWidth - cellPadding;
            $viewport.css({ width: visibleWidth + 'px', maxWidth: visibleWidth + 'px' });
        };

        // Remove all other expanded rows and reset their icons
        $('.browse-detail-row').not('#detail-row-' + recordId).remove();
        $('.open-browse-sections').not($icon).removeClass('fa-angle-up').addClass('fa-angle-down');

        // Toggle if already exists
        if ($existingDetailRow.length) {
            $existingDetailRow.remove();
            $icon.removeClass('fa-angle-up').addClass('fa-angle-down');
            // Re-enable the column-resize grips now that no section row is expanded
            if ($table.length) {
                $table.prev('.JCLRgrips').show();
            }
            $('.table_container').off('scroll.browseSectionSync');
            return;
        }

        // The column-resize grips are absolutely positioned over the whole table and
        // don't account for rows added after init, so they render on top of the
        // section content below - hide the grip overlay (not colResizable itself,
        // disabling it strips the JColResizer class and its padding reset, which
        // changes the table's cell padding) while a section row is expanded
        if ($table.length) {
            $table.prev('.JCLRgrips').hide();
        }

        // Insert loading row immediately
        const $detailRow = $(`
            <tr id="detail-row-${recordId}" class="browse-detail-row">
                <td colspan="${colSpan}" style="padding: 12px 16px; border-top: none;">
                    <div class="browse-section-viewport" style="overflow-x: hidden;">
<!--                        <div class="browse-section-viewport-header">Details</div>-->
                        <div class="browse-section-viewport-body">
                            <span class="text-muted"><i class="fas fa-spinner fa-spin mr-1"></i> Loading...</span>
                        </div>
                    </div>
                </td>
            </tr>
        `);

        $row.after($detailRow);
        $icon.removeClass('fa-angle-down').addClass('fa-angle-up');

        const $viewport = $detailRow.find('.browse-section-viewport');
        const $viewportBody = $detailRow.find('.browse-section-viewport-body');
        applyViewportWidth($viewport);

        // The viewport div lives inside a colspan-ed <td>, so native `position: sticky`
        // doesn't reliably pin it against the table's own horizontal scroll - mirror the
        // container's scrollLeft onto the viewport via transform instead, so it stays
        // flush with the visible left edge as the parent table is scrolled
        if ($scrollContainer.length) {
            const syncViewportPosition = function () {
                $viewport.css('transform', `translateX(${$scrollContainer.scrollLeft()}px)`);
            };

            syncViewportPosition();
            $('.table_container').off('scroll.browseSectionSync');
            // $scrollContainer.on('scroll.browseSectionSync', syncViewportPosition);
        }

        // Fetch sections
        $.ajax({
            url: `/browse/${tableId}/sections/${recordId}`,
            method: 'GET',
            success: function (response) {
                $viewportBody.html(response);
                applyViewportWidth($viewport);

                // Nested section tables are injected after the initial page load, so they
                // need to be initialized here to get column-resize support
                $detailRow.find('.resizeable-table').each(function (index, table) {
                    initResizableBrowseTable($(table));
                });

                $detailRow.find('table.button-container').each(function (index, table) {
                    initResizableButtonContainer($(table));
                });
            },
            error: function () {
                $viewportBody.html(`
                <div style="padding: 12px 16px;">
                    <span class="text-danger"><i class="fas fa-exclamation-circle mr-1"></i> Failed to load sections.</span>
                </div>
            `);
            }
        });
    });

    let confPopup = $('#delTabPop');
    let acceptDel = $('#accTableDel');
    let cancelDel = $('#cancelTableDel');
    let DelUrl, tid;

    $('#deleteTable').on('click', function (e) {
        e.preventDefault();
        confPopup.show();
        DelUrl = $(this).attr('href');
        tid = $(this).data('tid');
    });

    $('#init-create-pdo').on('click', function (e) {
        e.preventDefault();

        $.ajax({
            type : 'GET',
            url : '/zzzs/workorder/contacts',
            success: function (res){
                $('#pdo_contact').empty().append(res);
                $('#pdo_contact').selectpicker({
                    container: 'body',
                    noneSelectedText: translation.nothing_selected
                })
                .selectpicker('setStyle', 'btn-light', 'remove')
                .selectpicker('setStyle', 'btn-block', 'add')
                .siblings('.dropdown-menu')
                .addClass('user-company-dropdown');
                $('#create-pdo-modal').modal('toggle');
                $('#create-wo-pdo').show().prop('disabled', false).html(translation.create);
                $('.wo-pdos').addClass('d-none').html('<hr>');
            }
        })
    });

    $('#create-wo-pdo').on('click', function(e){
        e.preventDefault();

        let contact = $('#pdo_contact').val(),
            from = $('#pdo_period_from').val(),
            to = $('#pdo_period_to').val(),
            document_number = $('#pdo_document_number').val();

        if(!from.length || !to.length || !document_number.length){
            toastr.error("Please fill all the fields!");
            return;
        }

        let $btn = $('#create-wo-pdo');
        $btn.prop('disabled', true)
            .html('<i class="fas fa-spinner fa-spin mr-1"></i>' + translation.create);
        toastr.info(translation.creating_started);

        $.ajax({
            type : 'GET',
            url : '/zzzs/workorder/contacts/create',
            data : {
                contact,
                from,
                to,
                document_number
            },
            success: function (res) {
                if (res.success) {
                    toastr.success("Work order(s) has been created!");
                    $('.wo-pdos').html(res.data).removeClass('d-none');
                    $btn.prop('disabled', false).html(translation.create);
                }
            },
            error: function () {
                $btn.prop('disabled', false)
                    .html(translation.create);
            }
        });
    });

    cancelDel.on('click', function (e) {

        e.preventDefault();
        confPopup.hide();

    });

    acceptDel.on('click', function (e) {

        e.preventDefault();
        confPopup.hide();

        let data = {
            tid: tid
        };

        $.ajax({

            url: DelUrl,
            type: 'DELETE',
            data: data,
            success: function (res) {
                if (res.success) {
                    toastr.success("Table has been deleted!");
                    setTimeout(function (e) {
                        window.location.href = `/customize`;
                    }, 3000)
                } else {
                    toastr.error(`${res.message}`);
                }

            },
            error: function (xhr, status, error) {
                let res = xhr.responseText;
                console.log(res)
            }
        });

    });

    $('.toggle-records').on('click', function (e) {
        e.preventDefault();
        $('.toggle-records').removeClass('checked');
        $('.toggle-records').find('.fa-check').addClass('d-none');
        $(this).addClass('checked');
        $(this).find('.fa-check').removeClass('d-none');
        let type = $(this).attr('data-type');
        window.location = getUrlParams("access", type);
    });

    /**
     * get URL parameters
     * @param paramName
     * @param newValue
     * @returns {string}
     */
    function getUrlParams(paramName, newValue) {
        const url = window.location.href;
        const urlParts = url.split("?");
        if (urlParts.length >= 2) {
            const params = urlParts[1].split("&");
            let found = false;
            for (let i = 0; i < params.length; i++) {
                const paramParts = params[i].split("=");
                if (paramParts[0] === paramName) {
                    params[i] = paramName + "=" + newValue;
                    found = true;
                    break;
                }
            }
            if (!found) {
                params[params.length] = `${paramName}=${newValue}`;
            }
            return urlParts[0] + "?" + params.join("&");
        } else {
            return url + "?" + paramName + "=" + newValue;
        }
    }
});
// ── "Ask FreeLife" bar → on-demand AI chat panel ──────────────────────────
// Trigger bar (#ai-ask-bar) is in resources/views/tables/browse.blade.php. The panel
// markup (resources/views/tables/ai_chat_sidebar.blade.php) is fetched on first use
// via GET /chat/panel, appended to <body>, and wired up by chat.js / window.initFLChat().
$(document).ready(function () {

    var panelRequest = null;

    function ensureAiChatPanel() {
        if (document.getElementById('ai-chat-sidebar')) {
            return $.Deferred().resolve().promise();
        }
        if (!panelRequest) {
            panelRequest = $.get('/chat/panel').done(function (html) {
                $('body').append(html);
                if (typeof window.initFLChat === 'function') {
                    window.initFLChat();
                }
            }).fail(function () {
                panelRequest = null; // allow a retry on the next ask
            });
        }
        return panelRequest;
    }

    function openAiChat() {
        $('#ai-chat-sidebar').addClass('open').attr('aria-hidden', 'false');
        $('#ai-chat-backdrop').addClass('show');
    }

    function closeAiChat() {
        $('#ai-chat-sidebar').removeClass('open').attr('aria-hidden', 'true');
        $('#ai-chat-backdrop').removeClass('show');
    }

    // Enter in the input submits — explicit so a global key handler elsewhere can't swallow it.
    $(document).on('keydown', '#ai-ask-input', function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            $('#ai-ask-bar').trigger('submit');
        }
    });

    $(document).on('submit', '#ai-ask-bar', function (e) {
        e.preventDefault();
        var question = $.trim($('#ai-ask-input').val());
        if (!question) {
            return;
        }
        $('#ai-ask-input').val('');

        $.when(ensureAiChatPanel()).done(function () {
            openAiChat();
            // Hand the question to chat.js: it reads #user-input and sends on a native
            // click of #send-btn.
            $('#user-input').val(question);
            var sendBtn = document.getElementById('send-btn');
            if (sendBtn) {
                sendBtn.click();
            }
        });
    });

    $(document).on('click', '#ai-chat-close, #ai-chat-backdrop', closeAiChat);
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $('#ai-chat-sidebar').hasClass('open')) {
            closeAiChat();
        }
    });
});
